import api from "./axiosInstance";

const datosEmergenciaURL = "/personalContact";

const findDatosEmergenciaByUser = async (userID) => {
  const { data } = await api.get(`${datosEmergenciaURL}/${userID}`);
  return data;
};

const createDatosEmergencia = async (payload) => {
  const { data } = await api.post(datosEmergenciaURL, payload);
  return data;
};

const updateDatosEmergencia = async (payload, docID) => {
  const { data } = await api.put(`${datosEmergenciaURL}/${docID}`, payload);
  return data;
};

const deleteDatosEmergencia = async (docID) => {
  const { data } = await api.delete(`${datosEmergenciaURL}/${docID}`);
  return data;
};

export {
  findDatosEmergenciaByUser,
  createDatosEmergencia,
  updateDatosEmergencia,
  deleteDatosEmergencia,
};
